import {
  Component,
  input,
  OnDestroy,
  OnInit,
  output,
  viewChild,
  DestroyRef,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserGroups } from '@miq/shared-models';
import { MiqCheckboxMultigroupComponent } from '../miq-checkbox-multigroup/miq-checkbox-multigroup-component';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'miq-multiselectcheckbox',
  templateUrl: './multiselectcheckbox.component.html',
  styleUrl: './multiselectcheckbox.component.scss',
  imports: [MiqCheckboxMultigroupComponent, FormsModule, ReactiveFormsModule],
})
export class MultiselectcheckboxComponent implements OnInit, OnDestroy {
  protected destroyRef = inject(DestroyRef);
  userGroupOptions = input<UserGroups[]>([]);
  userListedGroups = input([]);
  groupChangeEvent = output<any>()
  public groupControl = new FormControl();
  multiGroupCheckbox = viewChild<MiqCheckboxMultigroupComponent>('multiGroupCheckbox');
  ngOnInit(): void {
    this.groupControl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.groupChangeEvent.emit(res);
    });
  }
  ngOnDestroy() {
    // REQUIRED by untilDestroyed
  }
}
